import { nebWalletConnector } from '../utils/nebWalletConnector'

export const injected = new nebWalletConnector({
  supportedChainIds: [1, 1001]
})
